import '@loyal/main.css'

import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { OidcProvider } from 'redux-oidc'
import { ConnectedRouter } from 'connected-react-router'
import { LastLocationProvider } from 'react-router-last-location'
import { HelmetProvider } from 'react-helmet-async'

import { userManager } from 'Auth'
import AppRouter from 'App/AppRouter'
import HeadMetadata from 'Shared/HeadMetadata'

const App = ({ store, history }) => (
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <ConnectedRouter history={history}>
        <LastLocationProvider>
          <HelmetProvider>
            <HeadMetadata />
            <AppRouter />
          </HelmetProvider>
        </LastLocationProvider>
      </ConnectedRouter>
    </OidcProvider>
  </Provider>
)

App.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

export default App



// WEBPACK FOOTER //
// ./src/App/App.js